import { combineReducers } from 'redux'

import { routerReducer as routing } from 'react-router-redux'

import auth from 'Global/Stores/auth'
import debug from 'Global/Stores/debug'
import familyAlbum from 'Global/Stores/familyAlbum'
import feedback from 'Global/Stores/feedback'
import group from 'Global/Stores/group'
import groups from 'Global/Stores/groups'
import layout from 'Global/Stores/layout'
import messages from 'Global/Stores/messages'
import modals from 'Global/Stores/modals'
import mySearches from 'Modules/MySearchesModule/reducer'
import options from 'Global/Stores/options'
import previewModal from 'Global/Stores/previewModal'
import previewModalGeneric from 'Global/Stores/previewModalGeneric'
import previewModalMain from 'Global/Stores/previewModalMain'
import previewModalPicture from 'Global/Stores/previewModalPicture'
import recent from 'Global/Stores/recent'
import reservations from 'Global/Stores/reservations'
import rugDetail from 'Global/Stores/rugDetail'
import rugs from 'Global/Stores/rugs'
import search from 'Modules/SearchModule/reducer'
import statistics from 'Global/Stores/statistics'
import userDetail from 'Modules/UserDetailModule/reducer'
import users from 'Modules/UsersModule/reducer'

const appReducer = combineReducers({
  auth,
  debug,
  familyAlbum,
  feedback,
  group,
  groups,
  layout,
  messages,
  modals,
  mySearches,
  options,
  previewModal,
  previewModalGeneric,
  previewModalMain,
  previewModalPicture,
  recent,
  reservations,
  routing,
  rugDetail,
  rugs,
  search,
  statistics,
  userDetail,
  users,
})

export default (state, action) => {
  return appReducer(state, action)
}
